import { Amplify } from 'aws-amplify';

// Helper to determine if we're in "local only" mode (dev server AND no Cognito pool ID)
const IS_LOCAL_ONLY_MODE = import.meta.env.DEV && !import.meta.env.VITE_COGNITO_USER_POOL_ID;

let effectiveAmplifyConfig = {};

if (IS_LOCAL_ONLY_MODE) {
  console.log('[AmplifyConfig] Running in LOCAL_ONLY_MODE. Amplify configured with minimal (dummy) settings.');
  // Provide a minimal valid configuration to prevent Amplify from throwing errors
  // when its modules are imported, even if we don't use its auth UI/calls.
  effectiveAmplifyConfig = {
    Auth: {
      region: 'us-east-1', // Dummy value, required by Amplify's type, but won't be used
      userPoolId: 'us-east-1_dummyLocalPoolId', // Dummy value
      userPoolWebClientId: 'dummyLocalClientId', // Dummy value
      mandatorySignIn: false,
      // NO oauth block for local-only mode, as federatedSignIn won't be called
    },
    // You can add other categories with dummy configs if Amplify complains for them too
    // e.g., API: { endpoints: [] }
  };
} else {
  // DEVELOPMENT (with Cognito vars from .env) or PRODUCTION mode
  console.log(`[AmplifyConfig] Running in full auth mode: ${import.meta.env.MODE}. Configuring with Cognito details.`);

  const baseAuthConfig = {
    region: import.meta.env.VITE_COGNITO_REGION,
    userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID,
    userPoolWebClientId: import.meta.env.VITE_COGNITO_USER_POOL_CLIENT_ID,
  };

  // Conditionally add oauth configuration only if the domain is set
  const oauthConfig = import.meta.env.VITE_COGNITO_OAUTH_DOMAIN
    ? {
        oauth: {
          domain: import.meta.env.VITE_COGNITO_OAUTH_DOMAIN,
          scope: ['email', 'profile', 'openid'],
          redirectSignIn: import.meta.env.VITE_COGNITO_OAUTH_REDIRECT_SIGNIN,
          redirectSignOut: import.meta.env.VITE_COGNITO_OAUTH_REDIRECT_SIGNOUT,
          responseType: 'code',
        },
      }
    : {};

  effectiveAmplifyConfig = {
    Auth: {
      mandatorySignIn: import.meta.env.MODE === 'production', // True for prod, false for dev-with-cognito
      ...baseAuthConfig,
      ...oauthConfig, // Spread oauthConfig; if empty (no domain), it adds nothing
    },
  };
}

/**
 * Configure Amplify at application start-up.
 */
export function configureAmplify() {
  Amplify.configure(effectiveAmplifyConfig);
} 